import order from './order'
import user from './user'
import mkt from './mkt'

export default {
  order,
  user,
  mkt
}
